<template>
  <NBox class="bg-neutral-quinary p-4 !h-[436px] overflow-scroll">
    <div v-for="(item, index) in position" :key="`POSITION_${index}`">
      <div
        v-if="item.type === 'quantity' && item?.condition"
        class="flex justify-between items-center py-2 h-8 border-b border-neutral-secondary"
      >
        <NText variant="caption1" weight="medium" class="text-neutral-primary">
          {{ item.label }}
        </NText>

        <NText
          variant="caption2"
          weight="medium"
          class="rounded-md py-0.5 px-1"
          :class="item.firstValue.customClass"
        >
          {{ item.firstValue.value }}
        </NText>
      </div>

      <div
        v-if="item.type === 'string' && item?.condition"
        class="flex justify-between items-start py-2 h-8"
      >
        <div class="flex items-center gap-1">
          <NText
            variant="caption1"
            weight="medium"
            class="text-neutral-primary"
          >
            {{ item.label }}
          </NText>

          <div
            v-if="item.firstValue?.icon"
            class="w-4 h-4 rounded-full bg-neutral-primary flex items-center justify-center"
          >
            <NegarLockIcon size="12" />
          </div>
        </div>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-primary"
          :class="item?.firstValue?.customClass"
        >
          {{ item.firstValue?.value }}
        </NText>
        <NText
          v-if="item.firstValue.prefix"
          variant="caption2"
          weight="medium"
          class="text-neutral-tertiary ms-1"
          :class="item.firstValue?.prefixClass"
        >
          {{ item.firstValue.prefix }}
        </NText>
      </div>

      <div
        v-if="item.type === 'number' && item.condition"
        class="flex justify-between items-center py-2 h-8"
      >
        <NText variant="caption1" weight="medium" class="text-neutral-primary">
          {{ item.label }}
        </NText>

        <Number
          :value="item.firstValue.value"
          #="{ number }"
          :round="item.firstValue.round"
        >
          <div>
            <NText
              dir="ltr"
              variant="caption1"
              weight="medium"
              :class="item.firstValue.customClass"
            >
              {{ number }}
            </NText>
            <NText
              v-if="item.firstValue.prefix"
              variant="caption2"
              weight="medium"
              class="text-neutral-tertiary ms-1"
              :class="item.firstValue?.prefixClass"
            >
              {{ item.firstValue.prefix }}
            </NText>
          </div>
        </Number>
      </div>

      <div
        v-if="item.type === 'dualValue' && item?.condition"
        class="flex justify-between items-center py-2 h-8"
      >
        <NText variant="caption1" weight="medium" class="text-neutral-primary">
          {{ item.label }}
        </NText>

        <div class="flex items-center gap-1">
          <NText>
            <Number
              #="{ number }"
              :value="item?.firstValue.value"
              :round="item.firstValue.round"
            >
              <NText
                dir="ltr"
                variant="caption1"
                weight="medium"
                :class="item.firstValue.customClass"
              >
                ({{ number }})
              </NText>
            </Number>
          </NText>
          <NText>
            <Number
              #="{ number }"
              :value="item?.secoundValue?.value"
              :round="item.secoundValue?.round"
            >
              <NText
                dir="ltr"
                variant="caption1"
                weight="medium"
                :class="item.secoundValue?.customClass"
              >
                {{ number }}
              </NText>
            </Number>
          </NText>
        </div>
      </div>

      <div
        v-if="item.type === 'dualValuePercent' && item?.condition"
        class="flex justify-between items-center py-2 h-8"
      >
        <NText variant="caption1" weight="medium" class="text-neutral-primary">
          {{ item.label }}
        </NText>

        <div class="flex items-center gap-1">
          <Number
            :value="item?.firstValue.value"
            #="{ number }"
            sign-display="exceptZero"
            number-style="percent"
            maximum-fraction-digits="2"
          >
            <NText
              dir="ltr"
              variant="caption1"
              weight="medium"
              :class="item.firstValue.customClass"
            >
              ({{ number }})
            </NText>
          </Number>

          <Number
            #="{ number }"
            :value="item?.secoundValue?.value"
            :round="item.secoundValue?.round"
          >
            <NText dir="ltr" variant="caption1" weight="medium">
              {{ number }}
            </NText>
            <NText
              variant="caption1"
              weight="medium"
              class="text-neutral-tertiary"
              :class="item.secoundValue?.prefixClass"
            >
              {{ item.secoundValue?.prefix }}
            </NText>
          </Number>
        </div>
      </div>
    </div>
  </NBox>
</template>

<script setup lang="ts">
import Number from '@/components/Number.vue';
import { TPositionType } from '../../utils/useGeneratePositionInfoDialogData';
import { NegarLockIcon } from '@negar/icons';

type TPositionInfoProps = {
  position: TPositionType[];
};

defineProps<TPositionInfoProps>();
</script>
